import { createContext } from 'react';

export interface LegacyContextProps {
  calculateOverflow?: <T>(items: Array<T>, limit: number) => [Array<T>, number];
  event?: (actionName: string) => void;
}

export const LegacyContext = createContext<LegacyContextProps>({});
